import React from "react";

import "../styles/customLoader.scss";
import CircularProgress from "@material-ui/core/CircularProgress";

const CustomLoader = ({
  loading = true,
  color = "#e2166e",
  text,
  fullScreen = false,
  marginTop = "100%",
  size = 20,
}) => {
  return (
    <div className={`custom-loader ${fullScreen ? "fullscreen" : ""}`}>
      <div className="loader-content" style={{ marginTop }}>
        <CircularProgress size={size} style={{ color: color }} />
        {text && <p className="loader-text">{text}</p>}
      </div>
    </div>
  );
};

export default CustomLoader;
